import React, { useEffect } from "react";

interface IRadioOption {
	label: string;
	value: string;
	disabled?: boolean; // Optional prop to disable a specific radio button
}

interface IRadioGroupSquareProps {
	options: IRadioOption[]; // Array of radio button options
	onChange: (selectedOption: IRadioOption) => void; // Callback to notify the parent with the selected option
	defaultSelected?: string; // Default selected value
}

const RadioGroupSquare: React.FC<IRadioGroupSquareProps> = ({
	options,
	onChange,
	defaultSelected,
}) => {
	const [selectedValue, setSelectedValue] = React.useState<
		string | undefined
	>(defaultSelected);

	// Synchronize state with defaultSelected prop whenever it changes
	useEffect(() => {
		if (defaultSelected !== undefined) {
			setSelectedValue(defaultSelected);
		}
	}, [defaultSelected]);

	const handleSelect = (option: IRadioOption) => {
		if (option.disabled) return; // Ignore disabled options

		setSelectedValue(option.value); // Update internal state
		onChange(option); // Notify parent about the change
	};

	return (
		<div className="bg-gray-100 flex items-start justify-center w-full drop-shadow-md">
			{options.map((option) => (
				<div
					key={option.value}
					className={`flex items-center w-full ${
						option.disabled
							? "cursor-not-allowed"
							: "cursor-pointer"
					}`}
					onClick={() => handleSelect(option)}
				>
					{/* Radio Button */}
					<div className="flex items-center justify-center w-full">
						{selectedValue === option.value ? (
							<span
								className={`bg-gradient-to-r from-sky-900 to-sky-600 p-4 px-4 font-semibold text-xl text-center text-md text-white w-full border-b-4 border-b-orange-500 ${
									option.disabled
										? "text-gray-700"
										: "text-gray-800"
								}`}
							>
								{option.label}
							</span>
						) : (
							<span
								className={`bg-gradient-to-r from-gray-400 to-gray-500 p-4 px-4 font-semibold text-xl  text-center text-md text-white w-full border-b-4 border-b-gray-500 ${
									option.disabled
										? "text-gray-700"
										: "text-gray-800"
								}`}
							>
								{option.label}
							</span>
						)}
					</div>
				</div>
			))}
		</div>
	);
};

export default RadioGroupSquare;
